export const ROOT = "/";
export const HOME = "/home";
export const ABOUT = "/about";
export const SEARCH = "/search";
export const CONTACT = "/contact";

export const LOGIN_ROUTE = "/login";
export const LOGOUT_ROUTE = "/logout";
export const REGISTER_ROUTE = "/register";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
